var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrinkingWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765172681778,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8061,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620.8 237.44m5.76 0l83.84 0q5.76 0 5.76 5.76l0 54.4q0 5.76-5.76 5.76l-83.84 0q-5.76 0-5.76-5.76l0-54.4q0-5.76 5.76-5.76Z",
    fill: "#ffffff",
    "p-id": 8062
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M768 674.56h-55.04V439.04h24.96a64 64 0 0 0 64-64V174.72a64 64 0 0 0-64-64h-448a64 64 0 0 0-64 64v199.68a64 64 0 0 0 64 64h24.96v235.52h-55.68a64 64 0 0 0-64 64v110.72a64 64 0 0 0 64 64H768a64 64 0 0 0 64-64v-110.08a64 64 0 0 0-64-64zM275.84 374.4V174.72a13.44 13.44 0 0 1 13.44-13.44h448a13.44 13.44 0 0 1 13.44 13.44v199.68a13.44 13.44 0 0 1-13.44 13.44h-448a13.44 13.44 0 0 1-13.44-13.44z m89.6 64h27.52l9.6 45.44a6.4 6.4 0 0 0 5.76 4.48h35.2A6.4 6.4 0 0 0 448 485.12l10.24-45.44h100.48l9.6 44.8a6.4 6.4 0 0 0 6.4 5.12h34.56a6.4 6.4 0 0 0 6.4-5.12l9.6-44.8h33.28v234.88H365.44z m412.8 409.6a13.44 13.44 0 0 1-13.44 13.44h-505.6a13.44 13.44 0 0 1-13.44-13.44v-109.44a12.8 12.8 0 0 1 13.44-12.8H768a12.8 12.8 0 0 1 13.44 12.8z",
    fill: "#ffffff",
    "p-id": 8063
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkingWater);
export default __webpack_public_path__ + "static/media/drinkingWater.1e51fc5c.svg";
export { ForwardRef as ReactComponent };